import { notFound } from "@tanstack/react-router";

import { isCatalogId } from "@garimpa/lib/catalogId";

import { setBadRequestResponseStatus } from "./response-status";

/**
 * Validate a catalog page parameter before any query is constructed or run.
 * Initial document requests receive HTTP 400; client navigations render the
 * same safe not-found boundary without attempting catalog access.
 */
export function requireCatalogPageId(value: string): string {
  if (isCatalogId(value)) return value;

  if (typeof window === "undefined") {
    setBadRequestResponseStatus();
  }

  throw notFound();
}
